import { useOutletContext } from "react-router";

import { WorkbenchContext } from "../types";

import WorkbenchRfpDetails from "./WorkbenchRfpDetails";

const RfpDetailsView = (): React.JSX.Element => {
  const context = useOutletContext<WorkbenchContext>();
  return <WorkbenchRfpDetails refetchRpfDetails={context.refetchRpfDetails} />;
};

export { RfpDetailsView };
